import { render, staticRenderFns } from "./EmployeeDocuments.vue?vue&type=template&id=1cdb788e&scoped=true&"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDocuments.vue?vue&type=style&index=0&id=1cdb788e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb788e",
  null
  
)

export default component.exports